import React, { useState } from "react";
import { myAxios } from "../../services/Helper";
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: ''
    });
    const [submitting, setSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            await myAxios.post('/enquiry', {
                userFullName: formData.name,
                mobileNo: formData.phone,
                email: formData.email,
                address: formData.address,
                message: formData.message
            });

            setSuccessMessage('Message sent successfully!');
            setFormData({
                name: '',
                email: '',
                phone: '',
                address: '',
                message: ''
            });
        } catch (error) {
            setErrorMessage('Failed to send message. Please try again.');
            console.error('Submission error:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="contact-page">
            <div className="contact-page-overlay">
                <div className="contact-header">
                    <h2>Contact Us</h2>
                    <div className="contact-header-underline"></div>
                    <p className="contact-tagline">Get in touch for more information about our services</p>
                </div>

                <div className="contact-container">
                    <div className="contact-sections">
                        <div className="contact-info-section">
                            <h3 className="contact-section-title">Our Contact Information</h3>
                            <div className="contact-info-wrapper">
                                <div className="contact-info-item">
                                    <div className="contact-icon">
                                        <i className="bi bi-envelope-fill"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h5>Email Address</h5>
                                        <p className="contact-value">anilwaghchaure@gmail.com</p>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-icon">
                                        <i className="bi bi-telephone-fill"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h5>Phone Number</h5>
                                        <p><span className="contact-label">Telephone:</span> <span className="contact-value">+81-245-54896</span></p>
                                        <p><span className="contact-label">Mobile:</span> <span className="contact-value">9370618124</span></p>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-icon">
                                        <i className="bi bi-geo-alt-fill"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h5>Address</h5>
                                        <p className="contact-value">Paithan gaon, Chh.Sambhajinagar</p>
                                    </div>
                                </div>

                                <div className="social-media-section">
                                    <h5 className="social-media-title">Connect with us</h5>
                                    <div className="contact-social-links">
                                        <a href="#" className="social-link" title="Facebook" aria-label="Facebook">
                                            <i className="bi bi-facebook"></i>
                                        </a>
                                        <a href="#" className="social-link" title="Instagram" aria-label="Instagram">
                                            <i className="bi bi-instagram"></i>
                                        </a>
                                        <a href="#" className="social-link" title="Twitter" aria-label="Twitter">
                                            <i className="bi bi-twitter"></i>
                                        </a>
                                        <a href="#" className="social-link" title="WhatsApp" aria-label="WhatsApp">
                                            <i className="bi bi-whatsapp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-form-section">
                            <h3 className="contact-section-title">Send Us a Message</h3>
                            {successMessage && <div className="alert alert-success">{successMessage}</div>}
                            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Your name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Your email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Your phone number"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Your address (optional)"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Message</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type your message here..."
                                        rows="4"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button
                                    type="submit"
                                    className="btn-submit"
                                    disabled={submitting}
                                >
                                    {submitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="map-section">
                    <div className="map-title-wrapper">
                        <h3 className="map-title">Find Us on Map</h3>
                        <div className="map-title-underline"></div>
                    </div>
                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3752.2280875532223!2d75.37868097482058!3d19.475033081979785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdb9815a369bc63%3A0x712d538b29a3d484!2sPaithan%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1685178990095!5m2!1sen!2sin"
                            width="100%"
                            height="400"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            title="Waghchaure Lawns Location"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;

